import {
  MotifCard,
  MotifCardBody,
  MotifCardFooter,
  MotifCardHeader,
  MotifTooltip,
} from "@ey-xd/motif-react";
import { useI18n } from "../../../hooks/useI18n";
import "./Card.scss";
import { Button } from "../Button/Button";
import { ArrowRightIcon } from "../../../icons";
const Card = ({
  cardHeader,
  cardBody,
  domain,
  onViewOrder,
  isAccessReady = true,
  isCoeMatched,
}) => {
  const { t } = useI18n();
  const isDID = domain === "DID";
  const isDisabled = !isDID && (!isCoeMatched || !isAccessReady);

  const handleClick = () => {
    if (isDID) {
      window.open(process.env.REACT_APP_DID_URL, "_blank", "noopener,noreferrer");
      return;
    }

    if (onViewOrder) {
      onViewOrder({ domain });
    }
  };

  const button = (
    <Button onClick={handleClick} size="small" variant="primary" disabled={isDisabled}>
      {t("vieworder")} <ArrowRightIcon />
    </Button>
  );

  return (
    <MotifCard
      className="motif-card"
      orientation="horizontal"
      variant="card-border"
    >
      <MotifCardHeader>
        <span className="motif-h6-default-regular">{t(cardHeader)}</span>
      </MotifCardHeader>
      <MotifCardBody className="motif-card-body">
        <p className="motif-body1-default-light">{t(cardBody)}</p>
      </MotifCardBody>
      <MotifCardFooter>
        {isDisabled ? (
          <MotifTooltip
            trigger={
              <span className="disabled-button-wrapper">{button}</span>
            }
            allowClick={false}
            allowHover={true}
            flip={true}
            hideCloseButton={true}
          >
            {t("You don't have access")}
          </MotifTooltip>
        ) : (
          button
        )}
      </MotifCardFooter>
    </MotifCard>
  );
};

export default Card;
